// extracted by mini-css-extract-plugin
export default {"container":"Tickets_container__bQHC6","topButtons":"Tickets_topButtons__vNJ0n"};